export default __webpack_public_path__ + "static/media/IMG_4578-min.90d35429.JPG";